/* eslint-disable func-style, one-var, no-underscore-dangle */

import settings from '@dc/ui-library/src/config/settings';
import normalizePostCode from '@dc/ui-library/src/helpers/normalizePostCode';

const addressForm = $('#new-customer, #delivery-address-edit');

let bindedSubmit = false;

export const addrLookup = function addrLookup(opts) {
  let suggestion = null;
  let remove = null;
  const finderHistory = {};
  const finderSectorHistory = {};
  let ajaxInProgress = false;

  if (!opts.message) {
    opts.message = 'Please enter a valid input';
  }

  function _updateForm(result) {
    const codeVal = (result[0].postcode) ? result[0].postcode : '',
      streetVal = (result[0].addressInfo.street) ? result[0].addressInfo.street : '',
      street2Val = (result[0].addressInfo.streetAlt) ? result[0].addressInfo.streetAlt : '',
      cityVal = (result[0].addressInfo.city) ? result[0].addressInfo.city : '',
      countyVal = (result[0].addressInfo.county) ? result[0].addressInfo.county : '';

    $(`input[name=${opts.inputs.code}]`).val(codeVal);
    $(`input[name=${opts.inputs.street}]`).val(streetVal);
    $(`input[name=${opts.inputs.street2}]`).val(street2Val);
    $(`input[name=${opts.inputs.city}]`).val(cityVal);
    $(`input[name=${opts.inputs.county}]`).val(countyVal);

    $(suggestion.parents('div')[0]).remove();
    suggestion = null;
  }

  /**
   * Beautify postcode, make upper case and add space if needed
   * set as value of input element
   * return formatted code or null
   * @private
   */
  function formatCode(codeElt) {
    let code = codeElt.val().toUpperCase().trim();
    if (code === '') {
      return code;
    }
    code = normalizePostCode(code);
    codeElt.val(code);
    return code;
  }

  /**
   * validate and return postal sector or null
   * @private
   */
  function getPostalSector(postcodeElt) {
    const formattedCode = formatCode(postcodeElt);
    const validationPattern = settings['postcode_sector.regex'];
    return formattedCode.match(validationPattern)
      ? formattedCode.match(validationPattern)[0] : null;
  }

  /**
   * Send validation request
   * if OK, calls _getResults
   * if not OK shows validationErrorMessage
   * @private
   */
  function validatePostCode() {
    hideValidationErrorMessage();
    const finderValue = formatCode($(opts.elt));
    const validationPattern = settings['postcode.regex'];
    const lookupRemoteUrl = settings.addressLookupUrl;

    if (finderValue && !ajaxInProgress && finderValue.match(validationPattern)) {
      if (!finderHistory.hasOwnProperty(finderValue)) {
        ajaxInProgress = true;
        $('#checkAddress').attr('disabled', 'disabled');
        $.ajax({
          url: (`${window.location.origin}${lookupRemoteUrl}/${finderValue.toLowerCase()}`),
          method: 'get',
          type: 'json',
          success: function(resp, textStatus, request) {
            finderHistory[finderValue] = resp;
            if (resp && request.statusText === 'OK') {
              hideValidationErrorMessage();
              _getResults(resp);
            } else {
              showValidationErrorMessage();
            }
          },
          complete: function() {
            ajaxInProgress = false;
            $('#checkAddress').removeAttr('disabled');
          },
          error: function(resp) {
            finderHistory[finderValue] = resp;
            showValidationErrorMessage();
          }
        });
      } else if (finderHistory[finderValue].length > 0) {
        _getResults(finderHistory[finderValue]);
      } else {
        showValidationErrorMessage();
      }
    } else if (finderValue || settings['validation.postcode.is_required'] === true) {
      showValidationErrorMessage();
    }
  }

  /**
   * Send validation request on postal sector
   * if OK submit registration form
   * if not OK shows validationErrorMessage
   * @private
   */
  function validatePostalSector(postcodeElt) {
    const lookupRemoteUrl = settings.addressLookupUrl;
    hideValidationErrorMessage();
    const postalSector = getPostalSector(postcodeElt);

    if (postalSector && !ajaxInProgress) {
      if (!finderSectorHistory.hasOwnProperty(postalSector)) {
        ajaxInProgress = true;
        $.ajax({
          url: (`${window.location.origin}${lookupRemoteUrl}/${postalSector.toLowerCase()}`),
          method: 'get',
          type: 'json',
          success: function(resp, textStatus, request) {
            if (request && (request.status === 200 || request.status === 204)) {
              addressForm.unbind('submit').submit();
            } else {
              showValidationErrorMessage();
            }
          },
          complete: function(resp) {
            finderSectorHistory[postalSector] = resp;
            ajaxInProgress = false;
          },
          error: function(jqXHR, textStatus) {
            if (textStatus !== 'timeout') {
              showValidationErrorMessage();
            } else {
              addressForm.unbind('submit').submit();
            }
          },
          timeout: 10000
        });
      } else if (finderSectorHistory[postalSector].length > 0) {
        addressForm.unbind('submit').submit();
      } else {
        showValidationErrorMessage();
      }
    } else if (settings['validation.postcode.is_required'] === true) {
      showValidationErrorMessage();
    } else {
      addressForm.unbind('submit').submit();
    }
  }

  /**
   * Shows the validation error message
   * prepend html, slide to message
   * @private
   */
  function showValidationErrorMessage() {
    const message = $('<div></div>');
    message.html(window.App.locale.getString('component.postcodeValidation.invalid_postcode'));
    message.addClass('dc-tooltip dc-tooltip-negative postCode-not-valid-error');
    $('#address-errors').html(message);
    $('#lookupRes').html('');
    $('html, body').stop().animate({ scrollTop: message.offset().top }, 200);
  }

  /**
   * Hide the validation error message
   * remove error message
   * @private
   */
  function hideValidationErrorMessage() {
    $('.postCode-not-valid-error').remove();
  }

  /**
   * Gets the addresses for a postcode and show a dropdown with the results
   * @private
   */
  function _getResults(wasSearched) {

    const loader =
      $('<p><label></label> <span class="loading"><span></span> Loading...</span></p>');

    loader.insertAfter($(opts.elt).parents('p'));

    if (!suggestion) {
      suggestion =
        $('<div><label>Select address :</label></div>').insertAfter($(opts.elt).parents('p'));
      suggestion = $('<ul id="lookupRes" class="simple select"></ul>').appendTo(suggestion);
      remove =
        $('<p><label></label><a href="#remove_suggestion">My address is not on the list</a></p>')
          .insertAfter(suggestion);
      remove.find('a').click((e) => {
        e.preventDefault();
        $(suggestion.parents('div')[0]).remove();
        suggestion = null;
        $($(opts.elt).parents('div')[0]).next().find('input').focus();
      });
    } else {
      suggestion.empty();
    }

    _updateSuggestion(wasSearched, suggestion);
    loader.remove();

    function _updateSuggestion(resp, suggest) {
      $(resp).each(function each(index, value) {
        let opt = $('<li></li>').appendTo(suggest);
        const result = $(this);

        opt = $(`<a tabindex="0" href="#">${value.partialAddress}</a>`).appendTo(opt);

        opt.click((e) => {
          e.preventDefault();
          _updateForm(result);
        });
      });
    }
  }

  $(opts.elt)
    .bind({
      focus: function() {
        $(opts.elt).bind('keypress', (e) => {
          if (e.keyCode === 13) {
            e.preventDefault();
            validatePostCode();
          }
        });
      },
      blur: function() {
        $(opts.elt).unbind('keypress');
      }
    })
    .next('.btn').click(() => {
      validatePostCode();
    });

  if (!bindedSubmit) {
    bindedSubmit = true;
    addressForm.on('submit', (e) => {
      e.preventDefault();

      if ($('input[data-auto-format-postcode]').length > 0) {
        $('input[data-auto-format-postcode]').each(function each() {
          formatCode($(this));
        });
      }

      setTimeout(() => {
        if (typeof addressForm.attr('data-gdpr-invalid') === 'undefined') {
          if ($('input[data-validate-postal-sector]').length > 0) {
            $('input[data-validate-postal-sector]').each(function each() {
              validatePostalSector($(this));
            });
          } else {
            addressForm.unbind('submit').submit();
          }
        }
      }, 0);
    });
  }
};

$(document).on('change', '#switchAddress.billing input', () => {
  if ($('#newAddress').is(':checked')) {
    $('#sPostalCode').removeAttr('data-validate-postal-sector');
    $('#s2ndPostalCode').attr('data-validate-postal-sector', true);
  } else {
    $('#sPostalCode').attr('data-validate-postal-sector', true);
    $('#s2ndPostalCode').removeAttr('data-validate-postal-sector');
  }
});
